import { Content, Grid, Column, Heading, Button } from '@carbon/react';
import { ArrowLeft, Home } from '@carbon/icons-react';
import { Link, useNavigate } from 'react-router-dom';

/**
 * NotFoundPage Component
 * 
 * 404 error page displayed when a route is not found.
 * Provides navigation options to return to the application.
 */
export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Content className="not-found-page">
      <Grid fullWidth>
        <Column lg={{ span: 8, offset: 4 }} md={8} sm={4}>
          <div className="not-found-content">
            <div className="error-code">404</div>
            
            <Heading className="error-title">
              Page Not Found
            </Heading>
            
            <p className="error-description">
              The page you're looking for doesn't exist or has been moved.
              Let's get you back on track.
            </p>

            <div className="error-actions">
              <Button
                kind="primary"
                renderIcon={Home}
                as={Link}
                to="/"
              >
                Go to Home
              </Button>
              
              <Button
                kind="secondary"
                renderIcon={ArrowLeft}
                onClick={() => navigate(-1)}
              >
                Go Back
              </Button>
            </div>

            <div className="error-suggestions">
              <p className="suggestions-title">You might be looking for:</p>
              <ul className="suggestions-list">
                <li>
                  <Link to="/">Home</Link> - Start page
                </li>
                <li>
                  <Link to="/editor">Ontology Editor</Link> - Create and edit ontologies
                </li>
                <li>
                  <Link to="/settings">Settings</Link> - Configure your preferences
                </li>
              </ul>
            </div>
          </div>
        </Column>
      </Grid>
    </Content>
  );
}

// Made with Bob
